const discountvalue = (state = 0, action) => {
    switch (action.type) {
      case "SET_Discount_Value":
        return action.payload; // Set the new discount value
      default:
        return state;
    }
  };
  
  export default discountvalue;